import { Licences as LicencesComponent } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box, Divider } from 'braid-design-system';
import React from 'react';

import { LICENCES } from 'src/components/Router';

import { graphQLLicenceToUILicence } from '../../Licences/utils';
import { useShareableProfile } from '../data';

import translations from './.vocab';

export const Licences = () => {
  const { shareableProfile, shareableProfileCardEmpty } = useShareableProfile();
  const { t } = useTranslations(translations);
  const licences = shareableProfile?.licences || [];

  return shareableProfileCardEmpty[LICENCES] ? null : (
    <>
      <Box id={LICENCES} paddingY="xxlarge" data-automation={LICENCES}>
        <Stack space="large">
          <Heading level="2" align="left">
            {t('Licences & certifications')}
          </Heading>
          <LicencesComponent
            displayVariant="full-text-no-divider"
            showVerifiedText={true}
            licences={licences.map((licence) => ({
              ...graphQLLicenceToUILicence(licence),
              showCertsyFunctionality: false,
              replaceUrlTextWithLinks: false,
            }))}
          />
        </Stack>
      </Box>
      <Divider weight="regular" />
    </>
  );
};
